import React from 'react';
import { Container, Nav, Navbar, Dropdown, Form } from 'react-bootstrap';
// import logoOsmata from './images/LOGO-OSMATA.png';
// import minilogoOsmata from './images/LOGO-OSMATA-SIN-LETRAS.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import styled from "styled-components";
import { useNavigate } from 'react-router-dom'
import { getCurrentJwt, setCurrentJwt, setCurrentRefreshToken } from '../../../utils/helpers/jwt.helpers';
import { useAuthContext } from '../../../context/auth';

const ContenedorTitulo = styled.div`
    color: ${({ theme }) => theme.text};
    font-size: 0.875rem; /* 14px por defecto en móviles */
    
    @media (min-width: 576px) {
        font-size: 1rem; /* 16px en pantallas sm y mayores */
    }
    
    @media (min-width: 768px) {
        font-size: 1.25rem; /* 20px en pantallas md y mayores */
    }
    
    @media (min-width: 992px) {
        font-size: 1.5rem; /* 24px en pantallas lg y mayores */
    }
`;

/**
 * @param string @titulo Título del menú principal de la pantalla. Ejemplo <span className="d-none d-sm-inline-block">Turnos Centros Recreativos SMATA</span><div className="d-block d-sm-none">Turnos Centros</div><div className="d-block d-sm-none">Recreativos SMATA</div>
 * @param char @deQuien Para mostrar el logo correspondiente en caso en que sea SMATA u OSMATA.
 * @param function @actionNav Acción que se quiera ejecutar cuando se haga clic en el navBar
 * @returns 
 */
const NavMenu = ({titulo, deQuien = "S", actionNav, theme, toggleTheme, menuAuxiliar, tituloMenuAuxiliar, iconoMenuAuxiliar = null}) => {

    const navigate = useNavigate();
    const token = getCurrentJwt();
    const { afiliado, setAfiliado } = useAuthContext();

    const actionNavFn = () => {
        if(actionNav) {
            actionNav();
            return;
        }
        navigate("/");
    }

    const logOut = e => {
        setAfiliado({})
        setCurrentJwt("")
        setCurrentRefreshToken("")
        navigate("/");
    }

    return (
        <header>

            <Navbar
                className="navbar-expand-sm navbar-toggleable-sm box-shadow mb-3"
                style={{
                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
                }}
            >
                <Container 
                    className="d-flex justify-content-between align-items-center"
                    style={{ 
                        maxWidth: '100%',
                        overflow: 'visible',
                        paddingLeft: '10px',
                        paddingRight: '10px'
                    }}
                    fluid
                >

                    <div
                        className="d-flex pointer justify-content-start align-items-center"
                        onClick={actionNavFn}
                        style={{
                            cursor: 'pointer',
                            flex: '1 1 auto',
                            minWidth: 0,
                            overflow: 'hidden'
                        }}
                    >

                        <Navbar.Brand 
                            className=" d-flex align-items-start"
                        >
                            { 
                                deQuien == "S" ?
                                    <>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height={65}
                                            width={200}
                                            viewBox="0 0 436 139"
                                            className="d-none d-sm-inline-block p-0 m-0"
                                        >
                                            <path fill="#00a13b" d="M54.1 9.6c-13.4 3.6-27.3 13.5-34.7 24.6C12.3 44.9 8.9 55.8 8.8 68c0 15.5-3.7 13.9 31.7 14.2l30.5.3-7.2-7.3c-4-3.9-7.7-7.2-8.3-7.2-.6 0-3.7 2.7-7 6s-6.3 6-6.7 6c-.4 0-.8-2.2-.8-5 0-4.8.3-5.3 6.1-11.5 3.4-3.6 6.8-6.5 7.6-6.5.8 0 3.9 2 6.7 4.5C66.5 65.8 67 66 72.9 66H79v16h14V66h13.6l3.7-4.5c2.1-2.5 4.4-4.5 5.1-4.5.8 0 4.5 2.9 8.4 6.5l6.9 6.5-.4-4.8c-.2-2.6-.6-6.2-.9-8l-.5-3.2H85.5c-23.9 0-43.5-.2-43.5-.5 0-.2 3.4-3.8 7.6-8l7.5-7.5h65l-3-4.3c-7-10.3-20.3-19.6-33.5-23.6-8.2-2.5-23.2-2.8-31.5-.5zM39 53.8c0 .4-2.7 3.7-6 7.2l-5.9 6.5-6.1-6.2c-3.3-3.5-6-6.7-6-7.3 0-.6 4.6-1 12-1 6.6 0 12 .3 12 .8zM171.9 40.3c-9.1 2.6-14.2 8.4-14.2 16.2 0 9.7 5.6 14.2 22.6 17.9 2.9.7 6.7 3.9 6.7 5.6 0 .6-1.1 2.2-2.5 3.5-2 2-3.4 2.5-7.8 2.5-6.1 0-12.3-1.9-16.8-5l-2.9-2.1v13l5.8 1.8c3.2 1 9.2 1.7 13.7 1.7 6.7.1 8.9-.3 13-2.5 8.9-4.5 12.3-13 8.7-21.3-2.3-5.2-6.1-7.5-16.3-10.1-9.9-2.4-10.9-3-10.9-6.4 0-6.7 11.2-8.4 21.4-3.2l5.7 2.8-.3-6-.3-6.1-4.4-1.3c-7-2-16.1-2.4-21.2-1zM207 67.5V95h12l.2-18.8.3-18.7 5.2 12 5.2 12h8.6l5-12 5-11.9.3 18.7.2 18.7h13V39.9l-7.6.3-7.5.3-5.8 13c-3.2 7.1-6.2 12.9-6.7 12.9-.5-.1-3.4-6-6.6-13l-5.7-12.9-7.5-.3-7.6-.3v27.6zM286.5 41.2c-1.7 4.5-17.5 52.4-17.5 53 0 .5 2.7.8 6 .8h5.9l1.6-5.5 1.6-5.5h18.5l1.8 5.5 1.7 5.5h12.7l-9.1-27.5-9.2-27.5h-6.8c-4.5 0-6.9.4-7.2 1.2zM297 64.9l2.8 9.1h-12.7l.9-2.8c4.2-13.2 5.3-16.3 5.7-15.9.2.3 1.7 4.6 3.3 9.6zM320 45v5h17v45h12V50h16V40h-45v5zM384.5 41.2c-1.7 4.5-17.5 52.4-17.5 53 0 .5 2.7.8 6 .8h5.9l1.6-5.5 1.6-5.5h18.5l1.8 5.5 1.7 5.5h12.7l-9.1-27.5-9.2-27.5h-6.8c-4.5 0-6.9.4-7.2 1.2zM395 64.9l2.8 9.1h-12.7l.9-2.8c4.2-13.2 5.3-16.3 5.7-15.9.2.3 1.7 4.6 3.3 9.6z" />
                                            <path fill="#00a13b" d="M101.2 85L87.8 99h-71l1.9 3.1c7 11 19.3 20.2 32.4 24.4 11.3 3.5 25.5 3.5 36.8 0 9.4-3 21.1-10.4 27.1-17.3 4.6-5.2 9.8-14.1 12.5-21.5l1.8-4.7-6.4-6c-3.5-3.2-6.8-5.9-7.4-5.9-.5 0-7 6.3-14.3 13.9z" />
                                        </svg>
                                        
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height={65}
                                            width={65}
                                            viewBox="0 0 141 135"
                                            className="d-inline-block d-sm-none"
                                        >
                                            <path fill="#00a13b" d="M54.2 6.6c-19.9 5.3-35.6 20.2-42.4 40.1-2.5 7.1-3 10.1-3 18.3 0 15.5-3.7 13.9 31.7 14.2l30.5.3-7.2-7.3c-4-3.9-7.7-7.2-8.3-7.2-.6 0-3.7 2.7-7 6s-6.3 6-6.7 6c-.4 0-.8-2.2-.8-4.9 0-4.5.4-5.2 6.1-11.5 3.3-3.6 6.8-6.6 7.6-6.6.8 0 3.8 2 6.6 4.5 4.9 4.3 5.4 4.5 11.4 4.5H79v16h14V63h13.6l3.7-4.5c2.1-2.5 4.4-4.5 5.1-4.5.8 0 4.5 2.9 8.4 6.5l6.9 6.5-.4-4.8c-.2-2.6-.6-6.2-.9-8l-.5-3.2H85.5c-23.9 0-43.5-.2-43.5-.5s3.5-3.9 7.8-8l7.7-7.5h64.6l-3-4.3c-7-10.3-20.3-19.6-33.5-23.6-8.1-2.5-23.2-2.8-31.4-.5zM39 50.8c0 .4-2.7 3.7-6 7.2l-5.9 6.5-6.1-6.2c-3.3-3.5-6-6.7-6-7.3 0-.6 4.6-1 12-1 6.6 0 12 .3 12 .8z" />
                                            <path fill="#00a13b" d="M101.2 82L87.8 96h-71l1.9 3.1c4.2 6.6 9.6 11.9 16.8 16.8 20.7 13.8 47.2 13.9 67.9 0 11.4-7.6 19.1-17.5 24.1-31.2l1.8-4.7-6.4-6c-3.5-3.2-6.8-5.9-7.4-5.9-.5 0-7 6.3-14.3 13.9z" />
                                        </svg>
                                    </>
                                :
                                    <>
                                        {/* <Image
                                            src={logoOsmata}
                                            style={{ height: '55px' }}
                                            alt="Logo"
                                            className="d-none d-sm-inline-block"
                                        />
                                        <Image
                                            src={minilogoOsmata}
                                            style={{ height: '55px' }}
                                            alt="Logo"
                                            className="d-inline-block d-sm-none"
                                        /> */}
                                    </>
                            }

                        </Navbar.Brand>

                        <Navbar.Brand 
                            className="pb-0 mb-0 ps-0 ps-md-3 d-flex align-items-end"
                        >
                            <ContenedorTitulo>
                                { titulo }
                            </ContenedorTitulo>
                        </Navbar.Brand>

                    </div>

                    { 
                        token && afiliado &&
                        <Nav.Item style={{ flexShrink: 0 }}>
                                                
                            <Dropdown  size='sm'>

                                <Dropdown.Toggle
                                    className='btn-light'
                                >
                                    <FontAwesomeIcon icon={faUserAlt} className="me-3" />
                                    <span className="me-2 d-none d-md-inline-block">{afiliado.nombreCompleto}</span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu 
                                    align="end"
                                    popperConfig={{
                                        modifiers: [
                                            {
                                                name: 'preventOverflow',
                                                options: {
                                                    boundary: 'viewport',
                                                    padding: 10
                                                }
                                            },
                                            {
                                                name: 'offset',
                                                options: {
                                                    offset: [0, 5]
                                                }
                                            }
                                        ]
                                    }}
                                    style={{ 
                                        maxWidth: 'min(calc(100vw - 20px), 280px)',
                                        right: '0 !important',
                                        left: 'auto !important'
                                    }}
                                >

                                    {/* <Dropdown.Item
                                        className='btn-sm ms-0'
                                        style={{ marginLeft: '0px' }}
                                        onClick={() => router.push("/Perfil")}
                                    >
                                        <FontAwesomeIcon icon={faUserAlt} className="me-3" />
                                        Mi perfil
                                    </Dropdown.Item> */}

                                    <div
                                        className='btn-sm ms-0'
                                        style={{ marginLeft: '0px', padding: '0.25rem 1rem' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                        }}
                                    >
                                        <Form.Check 
                                            type="switch"
                                            id="custom-switch"
                                            label="Modo oscuro"
                                            checked={!(theme === 'light')}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                toggleTheme();
                                            }}
                                        />
                                    </div>

                                    <Dropdown.Divider />

                                    <Dropdown.Item
                                        className='btn-sm ms-0'
                                        style={{ marginLeft: '0px' }}
                                        onClick={logOut}
                                    >
                                        <FontAwesomeIcon icon={faSignOutAlt} className="me-3" />
                                        Cerrar sesión
                                    </Dropdown.Item>

                                </Dropdown.Menu>

                            </Dropdown>

                        </Nav.Item> 
                    }
                    
                </Container>

            </Navbar>

        </header>
    );
}

export default NavMenu;